export default "__VITE_ASSET__3bcb2b6d__"